export enum HidableMenuKeys {
  TALK_NOW = 'talkNow',
  ONBOARDING = 'onboarding',
  FAQ = 'faq',
  GAME_RULES = 'gameRules',
  TEST_PREP_GUIDE = 'testPrepGuide',
  BILLING_HISTORY = 'billingHistory',
  PREFERENCES = 'preferences',
  LIVE_CLASS_SETUP = 'liveClassSetup',
  LIVE_CLASS_GUIDE = 'liveClassGuide',
}




// WEBPACK FOOTER //
// ./ts/app/shared/types/hidable-menu-keys.ts